import { FC, useEffect } from 'react';
import cx from 'classnames/bind';

import { getFormattedTime } from '@/utils/getFormattedTime';
import { useTimer } from '@/hooks/useTimer';

import styles from './Timer.module.scss';

const cn = cx.bind(styles);

interface TimerProps {
  title: string;
  src: string;
  modal: string;
  setModal: (value: string) => void;
  timer: number;
}

const Timer: FC<TimerProps> = ({ title, src, modal, setModal, timer }) => {
  const { time, pause } = useTimer(timer, setModal);
  const formattedTime = getFormattedTime(time);

  useEffect(() => {
    if (modal !== '') {
      pause();
    }
  }, [modal]);

  return (
    <div className={cn('container')}>
      <img className={cn('img')} src={src} alt="Пачка сигарет" />
      <div className={cn('text')}>{title}</div>
      <div className={cn('time')}>{formattedTime}</div>
    </div>
  );
};

export default Timer;
